import qs from "qs-lite";

const possible = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

/**
  * @param num Digit number
  */
const generateUID = (num) => {
  let text = ""

  for (var i = 0; i < num; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }

  const date = new Date();
  const d = date.getDate();
  const m = date.getMonth() + 1; //Month from 0 to 11
  const y = date.getFullYear();

  return text + '' + y + '' + (m <= 9 ? '0' + m : m) + '' + (d <= 9 ? '0' + d : d)
}

/**
  * @param src Image source
  */
const addPixel = function (src) {
  let img = document.createElement("img");
  img.src = src;
  img.style.width = "1px"
  img.style.height = "1px"
  img.style.display = "none"

  document.body.appendChild(img)
}


const sendAnalytic = function (data) {
  const domain = process.env.VUE_APP_ANALYTIC_URL

  let src = domain + "?" + qs.stringify(data)
  addPixel(src)
}

export {
  generateUID,
  addPixel,
  sendAnalytic
}
